'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

angular.module('msCore').directive('msValidatedInputGroup', ['translateInterpolateFilter', 'countryGdprConfig', function (translateInterpolateFilter, countryGdprConfig) {
  var _link = function _link(scope) {
    // Prevent semantic errors for 'aria-labelledby' (WCAG)
    scope.watchValidity = function () {
      // Skip the method if no 'isMacSafari' attr or it is MacOS device
      if (scope.isMacSafari === undefined || scope.isMacSafari) {
        return;
      }

      // Get current input element by 'name'
      var formElement = angular.element('input[name="' + scope.formElement.$name + '"]');

      // Watch validity changing
      scope.$watch(function () {
        return scope.formElement.$valid;
      }, function (newValue) {
        // Add 'aria-labelledby' if elment is invalid
        if (!newValue) {
          formElement.attr('aria-labelledby', scope.formElement.$name + 'Error');
          return;
        }

        // Remove 'aria-labelledby' if elment is valid
        formElement.removeAttr('aria-labelledby');
        return;
      });
    };

    // Resolve aria issues by using ng-bind instead of handlebars syntax
    scope.getErrorMessage = function (error) {

      // Get translate importableParams if any
      var importableParams = _getImportableParams(scope.formElement.$name, error);

      // Remove extra parameter from error code
      if (importableParams) {
        error = error.split('_')[0];
      }

      // Get error message translationId
      var validationMessageKey = (scope.translatePrefix || 'onboarding.account') + '.' + (scope.inputName || scope.formElement.$name) + '.errors.' + error;
      // Use translate filter
      var thisValidationMessage = translateInterpolateFilter(validationMessageKey, importableParams);

      // Strip html before display
      return _stripHTML(thisValidationMessage);
    };
  };

  function _getImportableParams(inputName, errorCode) {
    var _errorCode$split = errorCode.split('_'),
        _errorCode$split2 = _slicedToArray(_errorCode$split, 2),
        errorName = _errorCode$split2[0],
        paramValue = _errorCode$split2[1];

    if (paramValue) {
      return _defineProperty({}, errorName, paramValue);
    }

    if (inputName === 'checkboxAge') {
      return { minAge: countryGdprConfig.getFromStorage().minAge };
    }

    return null;
  }

  function _stripHTML(html) {
    var tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  return {
    templateUrl: 'core/templates/validatedInputGroup.html',
    restrict: 'A',
    transclude: true,
    replace: true,
    scope: {
      'formElement': '=msValidatedInputGroup',
      // (optional) Used to override 'onboarding.account' as the translation key prefix)
      'translatePrefix': '@',
      // (optional) Used to override default input names for translation keys (override 'password' with 'thisPassword')
      'inputName': '@',
      // (optional) Used to watch inputs validity and add/remove 'aria-labelledby', if no isMacSafari watch will not start
      // for input type 'text' or 'password' only!
      'isMacSafari': '<'
    },
    link: _link
  };
}]);